'use client';

import { PropsWithChildren, useReducer } from 'react';
import { GiftFlowContext, giftFlowReducer, initialState } from '../utils/giftContext';

export default function GiftProvider({ children }: PropsWithChildren) {
  const [giftFlowState, dispatchGiftFlow] = useReducer(giftFlowReducer, initialState);

  return <GiftFlowContext.Provider value={{ giftFlowState, dispatchGiftFlow }}>{children}</GiftFlowContext.Provider>;
}
